import { useMemo } from "react";
import { object } from "prop-types";
import { observer } from "mobx-react";
import {
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useEstimateStructure,
  useEstimateTableSettings,
  useVisibilityModeCellClassName,
  VisibilityButton
} from "@tools";
import { HeaderWorkTypeEditor } from "./HeaderWorkTypeEditor";
import { WorkTypeColumnExpand } from "./WorkTypeColumnExpand";
import { makeStyles } from "@material-ui/styles";
import { CELL_HEIGHTS } from "@utils";
import Grid from "@material-ui/core/Grid";

export const LastPinnedCellActions = observer(({ section }) => {
  
  const {
    blockExpansions,
    allowEdition,
    isLibrary,
    isPdfPrinterView,
  } = useEstimateEditorSettings();
  const { visibleWorkTypes } = useEstimateTableSettings();
  const { visibilityMode } = useEstimateEditorStore();
  const { visibility } = useEstimateStructure();
  const classes = useStyle();
  const { taskWorkTypes, hideEstimateCollapse: sectionHideEstimateCollapse } = section;
  const { apply, hideEstimateCollapse } = visibility;
  const estimateCollapseClassName = useVisibilityModeCellClassName(hideEstimateCollapse || sectionHideEstimateCollapse);
  
  const showEstimateCollapse = useMemo(() => (
    !isPdfPrinterView && (!apply || !(hideEstimateCollapse || sectionHideEstimateCollapse))
  ), [hideEstimateCollapse, apply]);
  
  const handleHideEstimateCollapse = (state) => {
    if(hideEstimateCollapse)
      visibility.setHideEstimateCollapse(false);
    else
      section.setHideEstimateCollapse(state);
  }
  
  return (
    <Grid item container wrap="nowrap" alignItems="center" className={classes.container}>
      {
        allowEdition && visibleWorkTypes.length === taskWorkTypes.length &&
        <HeaderWorkTypeEditor
          isLibrary={ isLibrary }
          section={ section }
          visibleWorkTypes={ visibleWorkTypes }
        />
      }
      {
        showEstimateCollapse && visibleWorkTypes.length > 0 &&
        <WorkTypeColumnExpand
          section={section}
          blockExpansions={blockExpansions || visibilityMode}
          className={estimateCollapseClassName}
        />
      }
      {
        visibilityMode &&
        <VisibilityButton
          size="tiny" inRow
          hidden={hideEstimateCollapse || sectionHideEstimateCollapse}
          onChange={handleHideEstimateCollapse}
          className={estimateCollapseClassName}
        />
      }
    </Grid>
  )
})

LastPinnedCellActions.propTypes = {
  section: object.isRequired,
}

const useStyle = makeStyles(() => ({
  container: {
    width: "max-content",
    height: CELL_HEIGHTS.XSMALL,
  },
}));